import { Theme } from '@mui/material';

const style = (theme: Theme): any => ({
    pinPos: {
        top: '50%',
        left: '50%',
        '-webkit-transform': 'translate(-50%, -80%)',
        transform: 'translate(-50%, -80%)',
        overflow: 'visible',
    },
    buttonIcon: {
        alignSelf: 'center',
        fontSize: 24,
    },
    pinContainer: {
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: theme.palette.background.default,
        borderRadius: '4px 6px 6px 4px',
        width: 'fit-content',
        transform: 'translateY(-10px)',
        height: 56,
        overflow: 'hidden',
        boxShadow: '0px 0px 10px rgb(0 0 0 / 10%)',
    },
    pinIconEta: {
        color: theme.palette.primary.contrastText,
        borderRadius: '4px 0px 0px 4px',
        alignSelf: 'center',
        padding: '17px',
        background: theme.palette.secondary.light,
    },
    pinAddressContainer: {
        alignSelf: 'center',
        background: theme.palette.background.default,
        borderRadius: '0px 4px 4px 0px',
        maxHeight: '48px',
        display: 'flex',
        flexDirection: 'row',
    },
    pinAddressText: {
        width: '150px',
        textAlign: 'left',
        display: '-webkit-box',
        margin: '0px 12px',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
        fontSize: 14,
        fontWeight: 400,
        letterSpacing: 0.2,
        color: theme.palette.colors.text.primaryButton,
        lineHeight: '20px',
        '& strong': {
            color: theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.secondary.light,
            fontWeight: 700,
        },
    },
    centerText: {
        textAlign: 'center',
    },
});

export default style;
